import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  reset(event) {
    event.preventDefault()
    const frame = this.element.closest("turbo-frame")
    if (frame) frame.innerHTML = ""
  }
}
